export default "__VITE_PUBLIC_ASSET__a4cf8922__"